const text = value => typeof value === 'string' ? value.trim() : '';
const point = value => value && typeof value.lat === 'number' && typeof value.lng === 'number'
  && Number.isFinite(value.lat) && Number.isFinite(value.lng) && Math.abs(value.lat) <= 85.0511
  && Math.abs(value.lng) <= 180 && (value.lat !== 0 || value.lng !== 0);

// This is a UI guard. Receipt authentication, locality and area qualification
// remain authoritative on the server; the Google entity is not authenticated.
export const isGoogleCheckoutSnapshot = (snapshot, now = Date.now()) => {
  const google = snapshot?.quality?.google;
  const acquiredAt = Date.parse(google?.acquiredAt);
  const deleteAt = Date.parse(google?.deleteAt);
  return Boolean(snapshot?.schema === 'brutos-delivery-location-v1' && snapshot.version === 1
    && snapshot.status === 'estimated' && snapshot.quality?.level === 'user-selected-point'
    && snapshot.quality?.provider === 'google-ui-kit' && point(snapshot.position)
    && google?.sourceProduct === 'places-ui-kit' && google.entityAttested === false && text(google.leaseId)
    && snapshot.quality.candidateId === `google-ui-kit:${google.leaseId}`
    && Number.isFinite(acquiredAt) && Number.isFinite(deleteAt) && acquiredAt <= now
    && deleteAt > now && deleteAt <= acquiredAt + 7 * 24 * 60 * 60 * 1000
    && snapshot.address?.country === 'BR' && text(snapshot.address?.city)
    && /^[A-Z]{2}$/.test(snapshot.address?.state || ''));
};

export const newGoogleCheckoutSessionKey = () => {
  if (typeof window === 'undefined' || !window.crypto?.getRandomValues) throw new Error('A busca complementar não está disponível neste navegador.');
  return Array.from(window.crypto.getRandomValues(new Uint8Array(24)), byte => byte.toString(16).padStart(2, '0')).join('');
};
